












































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import uuid from "uuid/v4";
import SectionList from "./SectionList.vue";
import DynamicForm from "../form/DynamicForm.vue";
import { InputTypes } from "@/store/form/types";

@Component({
  components: {
    SectionList,
    DynamicForm
  }
})
export default class FormBuilder extends Vue {
  store = this.$store.direct;

  tab = 0;

  get sections() {
    return this.store.state.template.selected.sections;
  }

  get valid() {
    return true;
  }

  addSection() {
    this.store.commit.template.ADD_SECTION_TO_SELECTED({
      id: uuid(),
      title: "",
      text: "",
      inputs: []
    });
  }

  @Watch("sections", { deep: true })
  onSectionChange() {
    let obj: { [key: string]: InputTypes } = {};
    this.sections.forEach(section => {
      section.inputs.forEach(input => {
        if (input.type == "radio" || input.type == "checkbox") {
          obj[input.name.toLowerCase()] = false;
        }
        if (input.type == "table") {
          obj[input.name.toLowerCase()] = [];
        }
      });
    });
    this.store.commit.form.UPDATE_SELECTED(obj);
  }
}
